import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  HostListener,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { SYDLEClientID } from "src/app/shared/constants/one-constants";
import { Dtm, getDtm } from "src/app/shared/enum/dtm";
import { Plan } from "src/app/shared/model/plan";
import { CatalogService } from "src/app/shared/services/catalog.service";
import { CustomerService } from "src/app/shared/services/customer.service";
import { DtmService } from "src/app/services/dtm.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { ShopWindowItem } from "../../shared/model/shop-window-item";
import { ShopWindowMessage } from "../../shared/model/shop-window-message";
import { DialogLoadingComponent } from "../../shared/components/dialog-loading/dialog-loading.component";
import { LoadingComponent } from "src/app/shared/components/loading/loading.component";
import { MatDialog } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { DialogAlertComponent } from "src/app/shared/components/dialog-alert/dialog-alert.component";
import { DiscountModalService } from "src/app/shared/services/discount-modal.service";
import { DialogData } from "src/app/shared/model/dialog-data";
import { FeatureItem } from "src/app/shared/model/feature-item";
import { max } from "moment";
import { Discount } from "src/app/shared/model/discount";

@Component({
    // tslint:disable-next-line: component-selector
    selector: "pme-checkout-my-plan",
    templateUrl: "./my-plan.component.html",
    styleUrls: ["./my-plan.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckoutMyPlanComponent {
  @ViewChild("stickyElement") stickyElement!: ElementRef;
  @ViewChild("divider-bottom-table") dividerElement!: ElementRef;
  packagesFilteredListLength: number;
  stickyPosition: number = 0;
  dividerPosition: number = 0;

  // Product Classifications (Old category)
  classificationIdentifier: string;
  selectedToggle: number = 0;

  // Titulo da vitrine
  shopWindowTitle = "Escolha o plano para assinar";

  // Array of Saude do Seu Negocio Plans
  plans: Array<ShopWindowItem> = [];
  periodicity: Array<string> = [];
  yearlyPlans: Array<ShopWindowItem> = [];
  monthlyPlans: Array<ShopWindowItem> = [];
  trimestralPlans: Array<ShopWindowItem> = [];
  semestralPlans: Array<ShopWindowItem> = [];
  toggleArray: string[] = ["Pré pago", "Assinatura"];
  packageIndex: number = 0;
  shopWindowMessage: ShopWindowMessage = null;
  coupon: string;
  hasAnyCoupon: boolean = false;

  mensalIndexToggle: number = -1;
  trimestralIndexToggle: number = -1;
  semestralIndexToggle: number = -1;
  anualIndexToggle: number = -1;


  verifyPlans = (el) => el.cardTitle !== "Plano Gratuito" || !this.userId;

  // Array of Asinatura's packages
  packages: Array<ShopWindowItem> = [];
  packagesLenght: number;
  sliderPackages: Array<ShopWindowItem> = [];
  monitoringFeatureList: Array<Object>;
  biggerDiscountAplied: string;
  myPlanErrors: Array<string> = [];
  // SessionStorage Variables

  //Parametros de checksum
  checksum: string;
  internalReference: string;
  ref: string;
  invalidChecksum: boolean;
  checksumData: any = null;

  userId: string;
  businessId: string;

  submitting: boolean;
  selectedPackage: ShopWindowItem;
  hasSelectedPackage: boolean = false;

  swiperButtonNext: HTMLElement;
  needSlider: boolean = false;
  sliderIndex: number = 0;
  sliderInitialWidth: number;
  onMobile: boolean;
  innerWidth: number;

  paymentMethodsImages = [
    "mastercard.png",
    "visa.png",
    "elo.png",
    "hipercard.png",
    "american-express.png",
    "diners-club.png",
    "discover.png",
    "boleto.png",
    "pix.png",
  ];

  someoneHasDiscountFloatBadge: boolean = false;

  constructor(
    public catalogService: CatalogService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private discountModalService: DiscountModalService,
    private elementRef: ElementRef
  ) {

  }

  onToggleChange(selectedIndex: number) {
    this.selectedToggle = selectedIndex;
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: "400px",
      panelClass: "pme-dialog-loading-panel",
      backdropClass: "pme-dialog-loading-backdrop",
    });
  }

  ngOnInit() {

    // this.openDialogSpinner();

    this.classificationIdentifier = this.sessionStorageService.getClassification(
      this.route
    );

    // // TODO - Colocar isto como um parametro no ONE
    // if (this.classificationIdentifier === "saude-do-seu-negocio") {
    //   this.shopWindowTitle = "Escolha o plano para assinar";
    // } else if (this.classificationIdentifier === "monitore-clientes") {
    //   this.shopWindowTitle = "Dê um upgrade no seu plano!";
    // }

    // const validatedMitigation = this.sessionStorageService.getValidatedMitigation();

    // this.catalogService
    //   .getProductsByClassification(
    //     this.classificationIdentifier,
    //     this.userId,
    //     validatedMitigation,
    //     this.coupon,
    //     this.businessId,
    //     this.checksumData
    //   )
    //   .subscribe(
    //     (shopWindow) => {

    //       this.sessionStorageService.setValidatedMitigation(
    //         shopWindow.validatedMitigation
    //       );

    //       if (shopWindow.invalidCS) {
    //         this.sessionStorageService.resetSessionStorage(true);
    //         this.openErrorDialog("checksum", "meu-plano");
    //       } else if (shopWindow.shopWindowItems) {
    //         const indexPreferred = shopWindow.shopWindowItems
    //           .map((el) => el.preferred && !el.disable)
    //           .indexOf(true);
    //         this.plans = shopWindow.shopWindowItems;

    //         this.plans.forEach((plan) => {
    //           let periodicityValue = plan.product.periodicity;
    //           if (!this.periodicity.includes(periodicityValue)) {
    //             this.periodicity.push(periodicityValue);
    //           }
    //         });

    //         this.monthlyPlans = this.plans.filter(
    //           (plan) => plan.product.periodicity === "Mensal"
    //         ).sort((a, b) => a.totalValue - b.totalValue);

    //         this.trimestralPlans = this.plans.filter(
    //           (plan) => plan.product.periodicity === "Trimestral"
    //         ).sort((a, b) => a.totalValue - b.totalValue);

    //         this.semestralPlans = this.plans.filter(
    //           (plan) => plan.product.periodicity === "Semestral"
    //         ).sort((a, b) => a.totalValue - b.totalValue);

    //         this.yearlyPlans = this.plans.filter(
    //           (plan) => plan.product.periodicity === "Anual"
    //         ).sort((a, b) => a.totalValue - b.totalValue);

    //         this.setIndices();

    //         this.checkMonitorePlan();
    //         if (this.classificationIdentifier === "plano-mensal") {
    //           this.packages = shopWindow.shopWindowItems;

    //           const periodicityOrder = [
    //             "Mensal",
    //             "Trimestral",
    //             "Semestral",
    //             "Anual",
    //           ];

    //           this.packages.sort((a, b) => {
    //             return (
    //               periodicityOrder.indexOf(a.product.periodicity) -
    //               periodicityOrder.indexOf(b.product.periodicity)
    //             );
    //           });

    //           this.getMaxFeatureListIndex(this.packages);
    //           this.biggerDiscountAplied = this.getBiggerDiscount(this.packages);
    //           // this.packages.forEach(pckg => {
    //           //   pckg.featureList = pckg.featureList.slice(3);
    //           //   pckg.monitoringFeatureList = pckg.featureList.slice(-2);
    //           //   pckg.featureList = pckg.featureList.slice(0, -2);
    //           // });

    //           this.hasAnyCoupon = this.packages.some(
    //             (pckg) => pckg.appliedDiscounts && pckg.appliedDiscounts.length
    //           );
    //           this.packagesLenght = this.packages.length;
    //           this.sliderPackages = [...this.packages];

    //           if (indexPreferred !== -1) {
    //             this.sliderPackages.splice(indexPreferred, 1);
    //             this.sliderPackages.unshift(this.packages[indexPreferred]);
    //           }

    //           const enabledProducts = this.packages.filter((el) => !el.disable);

    //           if (enabledProducts.length === 1) {
    //             this.handlePackageClick(
    //               this.packages.indexOf(enabledProducts[0])
    //             );
    //           } else {
    //             if (indexPreferred >= 0) {
    //               this.handlePackageClick(indexPreferred, true);
    //             }
    //           }
    //         } else {
    //           this.plans.forEach((plan) => {
    //             if (
    //               this.someoneHasDiscountFloatBadge === false &&
    //               plan.mapPaymentMethodAndDiscount[0]["CREDIT_CARD"].length > 0
    //             ) {
    //               this.someoneHasDiscountFloatBadge = true;
    //             }
    //           });
    //         }

    //         this.dtmService.productsLoaded(
    //           this.plans.map((plan) => ({
    //             classificationName: plan.product.classificationName,
    //             identifier: plan.product.identifier,
    //           }))
    //         );

    //         this.closeDialogSpinner();
    //         let isVendaDeslogada: any;
    //         isVendaDeslogada = sessionStorage.getItem("vendaDeslogada");

    //         if (!isVendaDeslogada) {
    //           isVendaDeslogada = this.sessionStorageService.getIsLogged();
    //         } else {
    //           isVendaDeslogada =
    //             isVendaDeslogada && isVendaDeslogada !== "true";
    //         }

    //         this.dtmService.customLoaded([]);
    //         this.dtmService.pageLoaded(
    //           Dtm.MeuPlano,
    //           isVendaDeslogada,
    //           getDtm(Dtm.MeuPlano, this.classificationIdentifier)
    //         );
    //         this.dtmService.sendPageLoadEvent();
    //         this.dtmService.customLoaded([
    //           "ProdImpression",
    //           "OverlayImpression",
    //         ]);
    //         this.dtmService.ruleChange("ProdImpression");

    //         this.dtmService.sendPageLoadEvent("ProdImpression");
    //       }
    //       if (shopWindow.shopWindowMessage) {
    //         this.shopWindowMessage = shopWindow.shopWindowMessage;
    //       }
    //     },
    //     (error) => {
    //       this.handleRequestError("getProductCatalogByCategory", error);
    //     },
    //     () => {}
    //   );
  }

  scrollUp() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.dtmService.sendSydleCustomEvent("Scroll-Monitore", {
      businessId: this.businessId || null,
      userId: this.userId || null,
      jorneyMappingEvent: "Scroll-Monitore",
    });
  }

  setIndices(): void {
    const desiredOrder = ["Anual", "Semestral", "Trimestral", "Mensal"];
    this.periodicity.sort((a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b));
    this.mensalIndexToggle = this.periodicity.indexOf("Mensal");
    this.trimestralIndexToggle = this.periodicity.indexOf("Trimestral");
    this.semestralIndexToggle = this.periodicity.indexOf("Semestral");
    this.anualIndexToggle = this.periodicity.indexOf("Anual");
  }

  getMaxFeatureListIndex(packages: any[]) {
    let maxFeatureListLength = 0;
    packages.forEach((pckg) => {
      if (pckg.featureList.length > maxFeatureListLength) {
        maxFeatureListLength = pckg.featureList.length;
        this.packageIndex = packages.indexOf(pckg);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let productsContainer = document.getElementsByClassName('products-container-assinatura');
    let packagesAvailable = document.getElementsByClassName('product-unit-assinatura');

    if( productsContainer.length === 0 || packagesAvailable.length === 0) return;

    let packagesDisplayed: Array<Element> = [];
    for (let i = 0; i < packagesAvailable.length; i++) {
      let displayed = packagesAvailable[i].getAttribute('style');
      if(displayed && displayed.match('display:flex')) packagesDisplayed.push(packagesAvailable[i]);
    }

    this.needSlider = ((window.innerWidth > 548 ) &&
    (window.innerWidth < productsContainer[0].clientWidth || packagesAvailable.length > packagesDisplayed.length) &&
    (packagesDisplayed.length > 0));

    if (this.needSlider) {
      this.sliderAction('left');
    } else {
      this.sliderAction('');
    }
    this.innerWidth = event.target.innerWidth;
    this.onMobile = this.innerWidth <= 960;
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {

    let productsContainer = document.getElementsByClassName('products-container-assinatura');
    let packagesAvailable = document.getElementsByClassName('product-unit-assinatura');

    if( productsContainer.length === 0 || packagesAvailable.length === 0) return;

    let packagesDisplayed: Array<Element> = [];
    for (let i = 0; i < packagesAvailable.length; i++) {
      let displayed = packagesAvailable[i].getAttribute('style');
      if(displayed && displayed.match('display:flex')) packagesDisplayed.push(packagesAvailable[i]);
    }

    this.needSlider = ((window.innerWidth > 548 ) &&
    (window.innerWidth < productsContainer[0].clientWidth || packagesAvailable.length > packagesDisplayed.length) &&
    (packagesDisplayed.length > 0));

    if (packagesDisplayed.length === 0) {
      this.sliderAction('');
    }
    // if(this.classificationIdentifier !== "descomplica" && this.classificationIdentifier !== "monitore-clientes" && this.classificationIdentifier !== "saude-do-seu-negocio"){
    //   const element = document.querySelectorAll(".sticky-element-assinatura");
    //   const windowScroll = window.pageYOffset;
    //   const windowWidth = window.innerWidth;
    //   if (windowScroll > this.stickyPosition +87  && windowWidth > 1280) {
    //     this.stickyElement.nativeElement.classList.add("fixed");
    //     element.forEach((element: any) => {
    //       element.style.position = "fixed";
    //     });
    //   } else {
    //     this.stickyElement.nativeElement.classList.remove("fixed");
    //     element.forEach((element: any) => {
    //       element.style.position = "relative";
    //     });
    //   }
    // }
  }

  ngDoCheck() {
    if (!this.swiperButtonNext) {
      this.swiperButtonNext = (<HTMLElement>(
        this.elementRef.nativeElement
      )).querySelector(".swiper-button-next");
    }

    if (this.swiperButtonNext) {
      this.swiperButtonNext.classList.add("wiggly");
    }
  }
  getValuesBasedOnFeatureList(featureList: any[], product: any) {
    let values = [];
    const mainFeatureList = featureList.map((feature) => feature.name);

    mainFeatureList.forEach((mainFeatureName) => {
      const matchingProductFeature = product.featureList.find(
        (productFeature) => productFeature.name === mainFeatureName
      );

      if (matchingProductFeature) {
        const value =
          matchingProductFeature.toValue ?? matchingProductFeature.fromValue;
        values.push(value);
      } else {
        values.push(null);
      }
    });

    return values;
  }

  setUrlParametersOnSessionStorage(): void {
    if (document.URL.includes("?")) {
      sessionStorage.setItem("urlParameters", "?" + document.URL.split("?")[1]);
    } else {
      sessionStorage.removeItem("urlParameters");
    }
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(
      this.userId,
      this.businessId
    );
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  errorHandler(error: any): void {
    this.myPlanErrors.push(error);
    this.dtmService.customErrorLoaded(["error"], {
      errorDetail: JSON.stringify(this.myPlanErrors),
      errorMessage:
        "Não foi possível buscar os catálogo de produtos. Tente novamente mais tarde",
    });
  }

  handleRequestError(request: string, err: any) {
    let errJson = err.error;
    try {
      if (typeof errJson === "string") {
        errJson = JSON.parse(errJson);
      }
    } catch (e) {}

    let errorDetail = errJson.generalMessages.map(
      (errorMessage: any) => errorMessage.text
    );

    if (errorDetail.includes("SHOP_WINDOW_BLOCKED_USER")) {
      this.openErrorDialog("mitigated", "meu-plano");
    } else {
      this.dtmService.customErrorLoaded(["error"], {
        errorDetail: JSON.stringify(errorDetail),
        errorMessage:
          "Não foi possível buscar os catálogo de produtos. Tente novamente mais tarde",
      });
    }
  }

  ngAfterViewInit(): void {
    if (this.stickyElement) {
      this.stickyPosition = this.stickyElement.nativeElement.offsetTop;
    }

    const dividerElement = document.querySelector(".divider-bottom-table");

    if (dividerElement) {
      this.dividerPosition =
        dividerElement.getBoundingClientRect().top + window.scrollY;
    }

    this.dtmService.pageLoaded(
      Dtm.MeuPlano,
      this.sessionStorageService.getIsLogged(),
      getDtm(Dtm.MeuPlano, this.classificationIdentifier)
    );

    this.discountModalService.discountModalConfig.subscribe(
      (newDiscountModalConfig) => {
        try {
          let discountModalConfig = JSON.parse(newDiscountModalConfig);

          if (
            discountModalConfig &&
            discountModalConfig.timeToActivateShopWindow
          ) {
            setTimeout(() => {
              //Impede o cenário que o cliente navegou para o pagamento sem ter ficado os 30 segundos na vitrine
              if (this.router.url.indexOf("meu-plano") > -1) {
                this.discountModalService.setReachedTheModalTime(true);
                this.discountModalService.setClickedOnPackages(true); // Fix temporario, enquanto a vitrine dos planos é antiga
              }
            }, discountModalConfig.timeToActivateShopWindow * 1000);
            //verificar f5 comportamento do reachedTheTimeModal
          }
        } catch (err) {}
      }
    );
  }

  private closeDialogSpinner() {
    this.dialog.closeAll();
  }

  /** Abre dialog em caso de erro durante a venda deslogada */
  openErrorDialog(dialogData, productIdentifier) {
    const data = DialogData.fromPreset(dialogData);
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: "pme-dialog-alert-panel",
      autoFocus: false,
      data: data,
    });

    // Analytics
    this.dtmService.customErrorLoaded(["error"], {
      errorDetail: errorDetail || productIdentifier,
      errorMessage: content,
    });
  }

  formatCurrency(value: number) {
    let valueString = String(value).replace(".", ",");
    let finalValue = valueString.includes(",")
      ? valueString.substr(0, valueString.indexOf(","))
      : valueString;

    if (valueString.includes(",")) {
      finalValue +=
        valueString.substr(valueString.indexOf(",")) +
        (valueString.substr(valueString.indexOf(",")).length === 2 ? "0" : "");
    }

    return finalValue;
  }

  handleSwiperPackageClick(i: number) {
    const index = this.packages.findIndex(
      (p) => p.product._id === this.sliderPackages[i].product._id
    );
    this.handlePackageClick(index);
  }

  handlePackageClick(i: number, autoClicked = false) {
    let oldSelectedPackage = null; // usado na lógica de des-selecionar pacotes

    if (this.packages[i] && this.packages[i].disable) {
      const enableProducts = this.packages.filter((pckg) => !pckg.disable);
      this.openErrorDialog("productDisabled", this.packages[i].product);
      return;
    }

    if (
      this.selectedPackage &&
      this.selectedPackage.selected &&
      this.selectedPackage === this.packages[i]
    ) {
      this.selectedPackage.selected = false;
    } else {
      oldSelectedPackage = this.selectedPackage;
      this.selectedPackage = this.packages[i];
      this.selectedPackage.selected = true;
      if (oldSelectedPackage && oldSelectedPackage !== this.selectedPackage) {
        this.packages[
          this.packages.indexOf(oldSelectedPackage)
        ].selected = false;
      }
    }

    this.hasSelectedPackage = this.packages.some(
      (pack) => pack.selected === true
    );

    // Adobe Analytics
    if (!autoClicked) {
      this.discountModalService.setClickedOnPackages(true);
      this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);
      this.dtmService.productsLoaded([
        {
          classificationName: this.selectedPackage.product.classificationName,
          identifier: this.selectedPackage.product.identifier,
        },
      ]);
      window.setTimeout(() => "", 500);
      this.dtmService.ruleChange("prodClick");
      this.dtmService.sendPageLoadEvent("prodClick");
    }
  }

  onSwipe() {
    this.swiperButtonNext.classList.remove("wiggly");
  }

  swiperConfig: any = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    watchOverflow: true,
    freeMode: true,
    slidesPerView: "auto",
  };

  recargaSwiperConfig: any = {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: "auto",
  };

  navigate(i: number, isSwipperClick: boolean) {
    this.submitting = true;
    if (isSwipperClick) {
      this.handleSwiperPackageClick(i);
    } else {
      this.handlePackageClick(i);
    }

    // Se existe uma targetURL no sessionStorage, usa-a pra navegar
    const targetUrl = sessionStorage.getItem("targetUrl");
    if (
      targetUrl &&
      targetUrl !== "" &&
      !targetUrl.includes("meu-pacote") &&
      !targetUrl.includes("consulta-e-recuperacao-de-dividas")
    ) {
      this.router.navigate([targetUrl]);
    } else if (this.selectedPackage.cardTitle === "Plano Gratuito") {
      let baseURL = "";
      if (environment.production) {
        baseURL = "https://www.serasaempreendedor.com.br/";
      } else {
        baseURL =
          "https://valfenda-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/";
      }
    } else {
      this.router.navigate(["../identificacao"], { relativeTo: this.route });
    }
    this.sessionStorageService.setProduct(
      this.selectedPackage.product.identifier
    );
    this.sessionStorageService.setClassification(
      this.selectedPackage.product.classificationIdentifier
    );
    this.sessionStorageService.setClassification(
      this.selectedPackage.product.classificationName
    );
  }

  checkMonitorePlan() {
    this.customerService
      .getContractStatusByProvisioningParameters(
        this.businessId,
        this.userId,
        "monitore-clientes"
      )
      .subscribe((result) => {
        if (result) {
          if (
            result.product.classification === "monitore-clientes" &&
            result.contractStatus === "ACTIVE"
          ) {
            this.removePremiumPlus();
          }
        }
      });
  }

  removePremiumPlus() {
    this.plans = this.plans.filter(
      (plan) =>
        plan.product.identifier !== "saude-do-seu-negocio-premium-plus-anual-2"
    );
  }

  getBiggerDiscount(packages: Array<ShopWindowItem>): string {
    let apliedDiscounts: Array<string> = [];
    let sumDiscounts = (discounts: Array<Discount>) => {
      return (
        discounts.reduce(
          (accumulator, currentValue) =>
            accumulator + Number(currentValue.deal.slice(0, 2)),
          0
        ) + "%"
      );
    };
    packages.forEach((item: ShopWindowItem) => {
      if (item.appliedDiscounts && item.appliedDiscounts.length > 0)
        apliedDiscounts.push(sumDiscounts(item.appliedDiscounts));
    });
    return apliedDiscounts && apliedDiscounts.length > 0
      ? apliedDiscounts.sort((a, b) => {
          return Number(b.slice(0, 2)) - Number(a.slice(0, 2));
        })[0]
      : null;
  }

  sliderAction(side: string) {

    let elements = document.getElementsByClassName('product-unit-assinatura');
    let products: Array<Element> = [];
    for (let i = 0; i < elements.length; i++) {
      products.push(elements[i]);
    }

    //Calculando quantos elementos cabem na tela
    let packagesDisplayed: Array<Element> = [];
    for (let i = 0; i < elements.length; i++) {
      let displayed = elements[i].getAttribute('style');
      if(displayed && displayed.match('display:flex')) packagesDisplayed.push(elements[i]);
    }
    let maxProductsDisplayed = Math.floor(window.innerWidth / ((packagesDisplayed && packagesDisplayed.length > 0) ? packagesDisplayed[0].clientWidth : elements[0].clientWidth));

    if(Math.ceil(elements.length/2) <= maxProductsDisplayed){
      products.forEach(product => product.setAttribute('style', 'display:none'));
      if (side === 'left') {
        products.splice(maxProductsDisplayed);
        this.sliderIndex = 0;
        products.forEach(product => product.setAttribute('style', 'display:flex'));
        return;
      }else if(side === 'right'){
        products.splice(0, elements.length - maxProductsDisplayed);
        this.sliderIndex = elements.length;
        products.forEach(product => product.setAttribute('style', 'display:flex'));
        return;
      }
      products.forEach(product => product.setAttribute('style', 'display:flex'));
      return;
    }

    //Mostrando e escondendo os pacotes de acordo com o slider
    if (side === 'left') {
      products.forEach(product => product.setAttribute('style', 'display:none'));
      if(this.sliderIndex === elements.length){
        if(maxProductsDisplayed === 3){
          products = products.splice(3,3);
        }else{
          products.splice(0, Math.floor(maxProductsDisplayed/2));
          products.splice(elements.length-Math.floor(maxProductsDisplayed/2), maxProductsDisplayed);
          if(products.length > maxProductsDisplayed) {
            let stop = products.length - maxProductsDisplayed;
            let head = true;
            for(let i=0; i< stop; i++){
              if(head) products.pop();
              else products.splice(0,1);
            }
          }
        }
        this.sliderIndex = Math.ceil(elements.length/2);
      }else if(this.sliderIndex === Math.ceil(elements.length/2)){
        products.splice(maxProductsDisplayed);
        this.sliderIndex = 0;
      }else{
        products.splice(maxProductsDisplayed);
        this.sliderIndex = 0;
      }
      products.forEach(product => product.setAttribute('style', 'display:flex'));
      return;
    }
    else if (side === 'right') {
      products.forEach(product => product.setAttribute('style', 'display:none'));
      if(this.sliderIndex === 0){
        if(maxProductsDisplayed === 3){
          products = products.splice(3,3);
        }else{
          products.splice(0, Math.floor(maxProductsDisplayed/2));
          products.splice(elements.length-Math.floor(maxProductsDisplayed/2), maxProductsDisplayed);
          if(products.length > maxProductsDisplayed) {
            let stop = products.length - maxProductsDisplayed;
            let head = true;
            for(let i=0; i< stop; i++){
              if(head) products.pop();
              else products.splice(0,1);
            }
          }
        }
        this.sliderIndex = Math.ceil(elements.length/2);
      }else if(this.sliderIndex === Math.ceil(elements.length/2)){
        products.splice(0, elements.length - maxProductsDisplayed);
        this.sliderIndex = elements.length;
      }else{
        products.splice(0, elements.length - maxProductsDisplayed);
        this.sliderIndex = elements.length;
      }
      products.forEach(product => product.setAttribute('style', 'display:flex'));
      return;
    }
    products.forEach(product => product.setAttribute('style', 'display:flex'));
  }

}
